module.exports = __webpack_public_path__ + "img/battlestar.df480e36.webp";